import { render, staticRenderFns } from "./buttons-section.vue?vue&type=template&id=1a741246&"
import script from "./buttons-section.vue?vue&type=script&lang=js&"
export * from "./buttons-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports